import axios from "axios";
import {FORBIDDEN_URL, LOGIN_URL} from "./common";

export const adminExportReport = async (params) => {
    try {
        const query = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (Array.isArray(value)) {
                value.forEach(v => query.append(`${key}[]`, v));
            } else if (value !== undefined && value !== null && value !== '') {
                query.append(key, value);
            }
        }

        const response = await axios.get(`/admin/reports?${query.toString()}`, {
            responseType: 'blob',
        });

        const disposition = response.headers['content-disposition'];
        let filename = 'report.xlsx';

        if (disposition && disposition.includes('filename=')) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        if (error.response?.status === 401) {
            window.location.href = LOGIN_URL;
        } else if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
        } else {
            console.error('Download failed:', error);
        }
    }
};


export const adminGetConversations = async ({status, page, per_page}) => {
    try {
        const response = await axios.get(`/admin/conversation/index?status=${status}&page=${page}&per_page=${per_page}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetConversationDetails = async (conversationId, {page, per_page}) => {
    try {
        const response = await axios.get(`/admin/conversation/${conversationId}?page=${page}&per_page=${per_page}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminChangeBrokerHasMav = async (vendorId, hasMav) => {
    try {
        const response = await axios.patch(`/admin/broker/${vendorId}/update/mav`, {has_mav: hasMav});
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminChangeBrokerHasSearchFeature = async (vendorId, hasSearchFeature) => {
    try {
        const response = await axios.patch(`/admin/broker/${vendorId}/update/search-feature-flag`, {has_search_feature: hasSearchFeature});
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetBrokerDetails = async (vendorId) => {
    try {
        const response = await axios.get(`/admin/broker/${vendorId}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetBrokers = async ({term, page, per_page, filters = {}}) => {
    try {
        const queryParams = new URLSearchParams({term, page, per_page, ...filters}).toString();
        const response = await axios.get(`/admin/broker/index?${queryParams}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetMAVRecords = async ({page, per_page, status}) => {
    try {
        const response = await axios.get(`/admin/mav/index?page=${page}&per_page=${per_page}&status=${status}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};


export const getMAVFiles = async (mavId, location) => {
    try {
        const response = await axios.get(`/conversation/${mavId}/filepath?location=${location}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get MAV files:', error);
        return null;
    }
};
export const uploadMAVFile = async (formData) => {
    try {
        const response = await axios.post('/admin/mav/image/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export const deleteMAVFile = async (location) => {
    try {
        const response = await axios.delete(`/admin/mav/image/remove?location=${encodeURIComponent(location)}`);
        return response.data;
    } catch (error) {
        console.error('Error delete MAV file:', error);
        throw error;
    }
};

export const addMAVData = async (formData) => {
    try {
        const response = await axios.post('/admin/mav/store', formData);
        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export const updateMAVData = async (mav_id, formData) => {
    try {
        const response = await axios.post(`/admin/mav/${mav_id}/update`, formData);

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export const deleteMavData = async (mav_id) => {
    try {
        const response = await axios.delete(`/admin/mav/${mav_id}/delete`);

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export const getAdminFilterVendors = async (term) => {
    try {
        const response = await axios.get(`admin/vendor/filter?term=${term}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error broker search vendor:', error);
        return null;
    }
};

export const getAdminFilterBrokers = async (term) => {
    try {
        const response = await axios.get(`admin/broker/filter?term=${term}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        // Handle any error that occurred during the API request
        console.error('Error admin search broker:', error);
        return null;
    }
};

export const adminGetDashboardVendors = async ({page, per_page, term = '', has_dashboard}) => {
    try {
        const response = await axios.get(`/admin/vendor/index?page=${page}&per_page=${per_page}&term=${term}&has_dashboard=${has_dashboard}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetAffiliateVendors = async ({page, per_page, term = '', has_affiliate}) => {
    try {
        const response = await axios.get(`/admin/vendor/index?page=${page}&per_page=${per_page}&term=${term}&has_affiliate=${has_affiliate}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetPlatformVendors = async ({page, per_page, term = '', has_platform}) => {
    try {
        const response = await axios.get(`/admin/vendor/index?page=${page}&per_page=${per_page}&term=${term}&has_platform=${has_platform}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetVendor = async (id) => {
    try {
        const response = await axios.get(`/admin/vendor/${id}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminUpdateVendor = async (id, value) => {
    try {
        const response = await axios.patch(`/admin/vendor/${id}/update/dashboard`, {has_dashboard: value});
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminUpdateVendorAffiliate = async (id, value) => {
    try {
        const response = await axios.patch(`/admin/vendor/${id}/update/affiliate`, {has_affiliate: value});
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminUpdateVendorPlatform = async (id, value, platformSlug = null) => {
    try {
        const payload = {
            has_platform_integration: value
        };
        if (platformSlug !== null) {
            payload.platform_slug = platformSlug;
        }
        const response = await axios.patch(`/admin/vendor/${id}/update/platform`, payload);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetAffiliateAccounts = async () => {
    try {
        const response = await axios.get(`/admin/ppc/affiliate/index?page=1&per_page=100`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetAffiliateClicks = async ({from = null, to = null, affiliate_id = null, page, per_page}) => {
    try {
        //add the params conditionally
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (affiliate_id) {
            const affIds = affiliate_id.toString().split(',')
            affIds.map((id, index) => {
                if (id)
                    params.append(`affiliate_ids[${index}]`, id);
                return true
            });

        }
        params.append('page', page);
        params.append('per_page', per_page);
        const response = await axios.get(`/admin/ppc/affiliate/clicks?${params.toString()}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        console.log('error', error);
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const getProducts = async () => {
    try {
        const response = await axios.get(`/admin/product/index`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminGetProductThesaurus = async ({page, per_page, product}) => {
    try {
        let url = `/admin/product/thesaurus?page=${page}&per_page=${per_page}`;

        if (product) {
            url += `&products=${product}`;
        }

        const response = await axios.get(url);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;

            return null;
        } else {
            return response.data;
        }

    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }

        return null;
    }
};

export const adminGetSsoAccounts = async () => {
    try {
        let url = `/admin/maintenance/account/duplicates`;

        const response = await axios.get(url);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;

            return null;
        } else {
            return response;
        }

    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;

            return null;
        }

        throw error;
    }
};

export const adminGetCompanyAccounts = async (companyId, companyType, searchTerm = null) => {
    try {
        let url = `/admin/maintenance/company/account/list?company_id=${companyId}&company_type=${companyType.toUpperCase()}`;

        if (searchTerm) {
            url += `&search_term=${encodeURIComponent(searchTerm)}`;
        }

        const response = await axios.get(url);

        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;

    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
            return null;
        }

        throw error;
    }
};

export const adminMergeSsoAccounts = async (originalAccountId, duplicateAccountId, dryRun = false) => {
    try {
        const response = await axios.post('/admin/maintenance/account/merge', {
            original_account_id: originalAccountId,
            duplicate_account_id: duplicateAccountId,
            dry_run: dryRun
        });

        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;

    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
            return null;
        }

        throw error;
    }
};

export const adminGetMergedAccounts = async () => {
    try {
        const response = await axios.get('/admin/maintenance/account/merged');

        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;

    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
            return null;
        }

        throw error;
    }
};

export const adminRestoreMergedAccount = async (mergedUserId, dryRun = false) => {
    try {
        const response = await axios.post(`/admin/maintenance/account/merged/${mergedUserId}/restore`, {
            dry_run: dryRun
        });

        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;

    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
            return null;
        }

        throw error;
    }
};

export const adminAddProductThesaurus = async (productId, thesaurus) => {
    try {
        const response = await axios.post(`/admin/product/thesaurus`, {product_id: productId, thesaurus: thesaurus});

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error adding thesaurus:', error);
        return null;
    }
};

export const adminUpdateProductThesaurus = async (id, thesaurus) => {
    try {
        const response = await axios.patch(`/admin/product/thesaurus/${id}`, {thesaurus: thesaurus});

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error updating thesaurus:', error);
        return null;
    }
};

export const adminDeleteProductThesaurus = async (id) => {
    try {
        const response = await axios.delete(`/admin/product/thesaurus/${id}`);

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error deleting product thesaurus:', error);
        return null;
    }
};

export const adminGetProductSpecificQuestions = async ({page, per_page}) => {
    try {
        const response = await axios.get(`/admin/product/psq?page=${page}&per_page=${per_page}`);

        if (response.status === 401) {
            window.location.href = LOGIN_URL;

            return null;
        } else {
            return response.data;
        }

    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }

        return null;
    }
};

export const adminGetFilteredProductSpecificQuestions = async (product) => {
    try {
        const response = await axios.get(`/admin/product/psq/filtered?product=${product}`);

        if (response.status === 401) {
            window.location.href = LOGIN_URL;

            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }

        return null;
    }
};

export const adminAddProductSpecificQuestion = async (productId, question, questionShort, hoverText, appearance) => {
    try {
        const response = await axios.post(`/admin/product/psq`, {
            product_id: productId,
            question: question,
            question_short: questionShort,
            hover_text: hoverText,
            appearance: appearance
        });

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error adding product specific question:', error);
        return null;
    }
};

export const adminUpdateProductSpecificQuestion = async (id, question, questionShort, hoverText, appearance) => {
    try {
        const response = await axios.patch(`/admin/product/psq/${id}`, {
            question: question,
            question_short: questionShort,
            hover_text: hoverText,
            appearance: appearance
        });

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error updating thesaurus:', error);
        return null;
    }
};

export const adminBatchUpdateProductSpecificQuestions = async (questions) => {
    try {
        const response = await axios.patch(`/admin/product/psq/reorder`, {
            questions: questions,
        });

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error updating thesaurus:', error);
        return null;
    }
};

export const adminDeleteProductSpecificQuestion = async (id) => {
    try {
        const response = await axios.delete(`/admin/product/psq/${id}`);

        if (response.status === 401) {
            return null;
        }

        return response;
    } catch (error) {
        console.error('Error deleting product specific question:', error);
        return null;
    }
};


export const adminGetEnvironments = async ({page, per_page, search_term, platform}) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('per_page', per_page);
        if (search_term) params.append('search_term', search_term);
        if (platform) params.append('platform', platform);

        const response = await axios.get(`/admin/environment?${params.toString()}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const adminAddEnvironment = async (payload) => {
    try {
        const response = await axios.post(`/admin/environment`, payload);
        if (response.status === 401) return null;
        return response;
    } catch (error) {
        console.error('Error adding environment:', error);
        return error.response;
    }
};

export const adminUpdateEnvironment = async (id, payload) => {
    try {
        const response = await axios.patch(`/admin/environment/${id}`, payload);
        if (response.status === 401) return null;
        return response;
    } catch (error) {
        console.error('Error updating environment:', error);
        return error.response;
    }
};

export const adminDeleteEnvironment = async (id) => {
    try {
        const response = await axios.delete(`/admin/environment/${id}`);
        if (response.status === 401) return null;
        return response;
    } catch (error) {
        console.error('Error deleting environment:', error);
        return null;
    }
};
